<template>
  <div class="Payment-main-container" v-if="false">
    <div v-if="$store.getters.checkoutPaymentMode == 1">
      <template v-if="$store.getters.checkoutStockStep == 1"></template>
      <template v-else-if="$store.getters.checkoutStockStep == 2">
        <confirmation></confirmation>
      </template>
    </div>
    <div v-else-if="$store.getters.checkoutPaymentMode == 2">
    </div>
  </div>
  <template v-if="depositRequired.value == true && depositCount.value > 0">
    <div class="Payment-main-container">
      <Deposit
        :paymentDoneAction="paymentDepositDoneAction"
        :depositAmount="depositAmount.value"
        :depositCurrency="depositCurrency"
        :depositCount="depositCount.value"
      ></Deposit>
    </div>
  </template>
  <div class="Payment-main-container" v-else>
   
    <payment-method
      :showRefundMessage="false"
      v-if="showPaymentMethods.value"
      :amount="getTotalAmount"
      :paymentDoneActionCard="paymentDoneActionCard"
      :paymentDoneActionWire="paymentDoneActionWire"
      :paymentDoneActionPayPal="paymentDoneActionPayPal"
    ></payment-method>
  </div>
</template>

<script>
import {reactive} from "@vue/reactivity";
import {computed} from "@vue/runtime-core";
import PaymentMethod from "./PaymentMethod.vue";
import Deposit from "./Deposit.vue";

import Confirmation from "../Confirmation.vue";
import store from "../../../../../store";
import GeneralVariables from "../../../../../common/utils/GeneralVariables";
import {loadStripe} from '@stripe/stripe-js'
let stripe

import {
  CREATE_CARD_PAYMENT,
  CREATE_DEPOSIT,
  CREATE_WIRE_PAYMENT,
  GET_PRICE_BREAKDOWN,
  UPDATE_STEPPER,
  REMOVE_KIT_FROM_CART,

} from "../../../store/actions";
import {useRouter} from "vue-router";
import { DONE, PENDING, SHOW_TOAST_MESSAGE } from "../../../../../common/store/actions";
import GeneralHelper from "../../../../../common/helpers/GeneralHelper";

export default {
  name: "Payment",
  components: {
    PaymentMethod,
    Deposit,
    Confirmation,
  
  },
  created() {
    var that = this;
    that.checkStage();
  
  },
  setup() {
    loadStripe(GeneralVariables.STRIPE_PUBLISHABLE_KEY).then(
    (result)=>{
      stripe = result
    })
    const router = useRouter();
    let showPaymentMethods = reactive({value: true});
    let depositRequired = reactive({value: false});
    let depositAmount = reactive({value: 0});
    let depositCurrency = reactive({});
    let depositCount = reactive({value: 0});

    let totalAmount = reactive({value: 0});

    const checkCurrentState = () => {
      var toConfi = true;
      store.getters.detailedCartItems.forEach((element) => {
        if (
          element.is_completed == null ||
          element.is_completed == undefined ||
          (element.is_completed == false && element.availibilityId == 4)
        )
          toConfi = false;
      });
      if (toConfi) {
        store.dispatch(UPDATE_STEPPER, ["confirmationDisplayActive"]);
        store.commit("checkoutActiveComponent", Confirmation);
        store.commit("setStepperDisplays", [1, 1, 1, 1, 1, 1]);
        return;
      }
    };
    function cleanCartAfterPayment(items) {
      let kit_ids = [];
      items.forEach(function (item) {
        kit_ids.push(item.kit);
      });
      kit_ids.forEach(function (kit_id) {
        store.dispatch(REMOVE_KIT_FROM_CART, {
          id: store.getters.customer.id,
          kit_id: kit_id,
        });
      });

      store.commit("setStepperDisplays", [0, 0, 1, 1, 1, 1]);
    }
    const paymentDoneActionCard = (data) => {
      
      store.dispatch(CREATE_CARD_PAYMENT, data).then((result) => {
        let client_secret = result.client_secret
        stripe.confirmCardPayment(client_secret).then((res)=>{
          if (res.error == undefined)
          {
            store.dispatch(DONE)
            store.dispatch(GET_PRICE_BREAKDOWN).then((result) => {
              checkCurrentState();
              let items = store.getters.cartItems;
              cleanCartAfterPayment(items);
            });
          }
          else{
            store.dispatch(DONE)
            store.dispatch(SHOW_TOAST_MESSAGE, GeneralHelper.buildMessage(3, res.error.message))
          }
        })
      });
    };
    const paymentDoneActionPayPal = (data) => {
      store.dispatch(CREATE_CARD_PAYMENT, data).then((result) => {
        store.dispatch(GET_PRICE_BREAKDOWN).then((result) => {
          checkCurrentState();
          let items = store.getters.cartItems;
          cleanCartAfterPayment(items);
        });
      });
    };
    const paymentDoneActionWire = () => {
      store.dispatch(CREATE_WIRE_PAYMENT).then((result) => {
        store.dispatch(GET_PRICE_BREAKDOWN).then(() => {
          checkCurrentState();
          let items = store.getters.cartItems;
          cleanCartAfterPayment(items);
        });
      });
    };

    const checkStage = () => {
      depositRequired.value = false;
      depositCount.value = 0;
      store.dispatch(GET_PRICE_BREAKDOWN).then(() => {
        store.getters.detailedCartItems.forEach((kit) => {
          if (kit.is_deposit && !kit.is_deposit_paid) {
            depositRequired.value = true;
            depositAmount.value += kit.deposit_amount;
            depositCurrency = {symbol: kit.currencySymbol};
            depositCount.value++;
          }
        });
      });
    };

    const getTotalAmount = computed(() => {
      var kits = store.getters.detailedCartItems;
      var total = 0;
      kits.forEach((element) => {
        if (store.getters.status_id == 1) {
          if (element.availibilityId == 4) total += element.cTotal;
        } else {
          total += element.cTotal;
        }
      });
      return total;
    });

    const payRemaing = () => {
      showPaymentMethods.value = true;
    };

    const paymentDepositDoneAction = (card) => {
      store.dispatch(CREATE_DEPOSIT, card).then((result) => {
        store.dispatch(GET_PRICE_BREAKDOWN).then((result) => {
          checkStage();
        });
      });
    };

    return {
      paymentDoneActionCard,
      paymentDoneActionWire,
      paymentDepositDoneAction,
      checkStage,
      depositAmount,
      depositCount,
      depositRequired,
      payRemaing,
      totalAmount,
      showPaymentMethods,
      depositCurrency,
      getTotalAmount,
    };
  },
};
</script>

<style lang="scss">
.button-active {
  color: white !important;
  height: 32px;

  background: $tertiary-color 0% 0% no-repeat padding-box !important;
  border-radius: 4px 4px 0px 0px !important;
  padding: 0 30px;
  opacity: 1;
}
.button-inactive {
  @extend .button-active;
  background: $dark-grey 0% 0% no-repeat padding-box !important;
}
.Payment-main-container {
  max-width: 600px;
  margin: 30px auto 20px auto;
  padding-bottom: 30px;
}
</style>
